import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }

import { Protocol } from "@/models/Protocol";
import { SummaryItem } from "@/notifi_types";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  protocol: { type: Protocol, required: false },
},
  async setup(__props) {

let __temp: any, __restore: any

const props = __props

const items = ref<SummaryItem[]>([]);
const loading = ref(false);

// eslint-disable-next-line no-undef

const activeProtocol = ref(props.protocol || new Protocol());

const fetchItems = async (): Promise<void> => {
  if (activeProtocol.value) {
    loading.value = true;
    const newItems = await activeProtocol.value.subscriptionSummary();
    items.value.length = 0;
    items.value.push(...newItems);
    loading.value = false;
  }
};
;(
  ([__temp,__restore] = _withAsyncContext(() => fetchItems())),
  await __temp,
  __restore()
);

return (_ctx: any,_cache: any) => {
  const _component_va_data_table = _resolveComponent("va-data-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_va_data_table, {
      loading: loading.value,
      items: items.value
    }, null, 8, ["loading", "items"])
  ]))
}
}

})